import React from 'react'
import { Segment } from 'semantic-ui-react'

const NotImplemented: React.FC = () => {
    return (
        <div style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '4px' }}>
            Darn it! -- you caught me, this is feature is being built; please let me know how urgently you want this working :).
        </div>
    )
}

export default NotImplemented
